var render, staticRenderFns
import script from "./TablerIcon.vue?vue&type=script&lang=js"
export * from "./TablerIcon.vue?vue&type=script&lang=js"
import style0 from "./TablerIcon.vue?vue&type=style&index=0&id=a1735fee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports